"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ViewFieldKey = void 0;
// eslint-disable-next-line no-shadow
var ViewFieldKey;
(function (ViewFieldKey) {
    // GENERIC
    ViewFieldKey["ROWKEY"] = "rowkey";
    ViewFieldKey["ID"] = "id";
    ViewFieldKey["TITLE"] = "title";
    ViewFieldKey["TITLEALT"] = "titleAlt";
    ViewFieldKey["DESCRIPTION"] = "description";
    ViewFieldKey["PLACE"] = "place";
    ViewFieldKey["ASSIGNED_PLACES"] = "places";
    ViewFieldKey["ASSIGNED_TEAMS"] = "teams";
    ViewFieldKey["TEAM"] = "team";
    ViewFieldKey["UPDATEDDATE"] = "updatedDate";
    ViewFieldKey["CREATEDDATE"] = "createdDate";
    // QUESTION ANSWERS
    ViewFieldKey["QUESTIONANSWER"] = "questionAnswer";
    // ALERT
    ViewFieldKey["ALERT_SENTDATE"] = "sentDate";
    // ASSET
    ViewFieldKey["ASSET_TYPE"] = "assetType";
    ViewFieldKey["ASSET_MANUFACTURER"] = "assetManufacturer";
    ViewFieldKey["ASSET_MODEL"] = "assetModel";
    ViewFieldKey["ASSET_SERIALNO"] = "assetSerialNo";
    ViewFieldKey["ASSET_LASTSERVICEDATE"] = "lastServiceDate";
    ViewFieldKey["ASSET_WHERE"] = "assetWhere";
    ViewFieldKey["ASSET_CUSTOMFIELD_0"] = "customField0";
    ViewFieldKey["ASSET_CUSTOMFIELD_1"] = "customField1";
    ViewFieldKey["ASSET_CUSTOMFIELD_2"] = "customField2";
    ViewFieldKey["ASSET_CUSTOMFIELD_3"] = "customField3";
    ViewFieldKey["ASSET_CUSTOMFIELD_4"] = "customField4";
    ViewFieldKey["ASSET_CUSTOMFIELD_5"] = "customField5";
    ViewFieldKey["ASSET_CUSTOMFIELD_6"] = "customField6";
    ViewFieldKey["ASSET_CUSTOMFIELD_7"] = "customField7";
    ViewFieldKey["ASSET_CUSTOMFIELD_8"] = "customField8";
    ViewFieldKey["ASSET_CUSTOMFIELD_9"] = "customField9";
    // ISSUE
    ViewFieldKey["ISSUE_ASSIGNEDTO"] = "assignedTo";
    ViewFieldKey["ISSUE_STATUS"] = "issueStatus";
    ViewFieldKey["ISSUE_FLAG"] = "issueFlag";
    ViewFieldKey["ISSUE_TYPE"] = "issueType";
    ViewFieldKey["ISSUE_OCCURRENCE"] = "occurrenceDate";
    ViewFieldKey["ISSUE_OP"] = "issueOp";
    ViewFieldKey["ISSUE_LASTCOMMENT"] = "lastComment";
    ViewFieldKey["ISSUE_CREATEDBY"] = "createdBy";
    ViewFieldKey["ISSUE_DEADLINEDATE"] = "deadlineDate";
    ViewFieldKey["ISSUE_CLOSEDDATE"] = "closedDate";
    ViewFieldKey["ISSUE_CLOSEDBY"] = "closedBy";
    ViewFieldKey["ISSUE_RESOLUTION_TIME"] = "resolutionTime";
    ViewFieldKey["ISSUE_DUESTATUS"] = "lateness";
    ViewFieldKey["ISSUE_ASSET"] = "issueAsset";
    ViewFieldKey["ISSUE_CAUSES"] = "issueCauses";
    ViewFieldKey["ISSUE_CORRECTIVEACTIONS"] = "issueCorrectiveActions";
    ViewFieldKey["ISSUE_PREVENTATIVEACTIONS"] = "issuePreventativeActions";
    // OPS GENERIC
    ViewFieldKey["OPS_TYPE"] = "opType";
    ViewFieldKey["OPS_ASSIGNEE"] = "assignee";
    ViewFieldKey["OPS_ASSOCIATED_STAFF"] = "associatedStaff";
    // OPDEFINITION
    ViewFieldKey["OPDEFINITION_WHERE"] = "opDefWhere";
    ViewFieldKey["OPDEFINITION_WHO"] = "opDefWho";
    ViewFieldKey["OPDEFINITION_FEATURES"] = "scheduled";
    ViewFieldKey["OPDEFINITION_PUBLISHED"] = "published";
    // OP
    ViewFieldKey["OP_ACTUALSTART"] = "actualStart";
    ViewFieldKey["OP_ACTUALCOMPLETE"] = "actualComplete";
    ViewFieldKey["OP_COMPLETEBY"] = "completeBy";
    ViewFieldKey["OP_SUBMITTEDBY"] = "submittedBy";
    ViewFieldKey["OPDEFINITION_ENABLED"] = "opDefinitionEnabled";
    ViewFieldKey["OP_ISADHOC"] = "isAdhoc";
    ViewFieldKey["OP_STATUS"] = "opStatus";
    ViewFieldKey["OP_PASSSTATUS"] = "opPassStatus";
    ViewFieldKey["OP_SCORE"] = "scorePercentage";
    ViewFieldKey["OP_ISSUES"] = "opIssues";
    ViewFieldKey["OP_STARTFROM"] = "startFrom";
    ViewFieldKey["OP_GRADE"] = "grade";
    // ORGANISATION
    ViewFieldKey["ORG_STATUS"] = "orgStatus";
    ViewFieldKey["ORG_TAGS"] = "orgTags";
    ViewFieldKey["ORG_ONBOARDING_SKIPPED"] = "onboardingSkipped";
    ViewFieldKey["ORG_ONBOARDING_COMPLETED"] = "onboardingCompleted";
    ViewFieldKey["ORG_ONBOARDING_ABANDONED"] = "onboardingAbandoned";
    ViewFieldKey["ORG_HASCREATED_FIRSTOPPLAN"] = "hasCreatedFirstOpPlan";
    ViewFieldKey["ORG_HASCREATED_FIRSTPLACE"] = "hasCreatedFirstPlace";
    ViewFieldKey["ORG_HASCREATED_FIRSTTEAM"] = "hasCreatedFirstTeam";
    ViewFieldKey["ORG_HASCREATED_FIRSTSTAFF"] = "hasCreatedFirstStaff";
    ViewFieldKey["ORG_HASCREATED_FIRSTPOSITION"] = "hasCreatedFirstPosition";
    ViewFieldKey["ORG_HASCREATED_FIRSTTEAMBOARD"] = "hasCreatedFirstTeamboard";
    ViewFieldKey["ORG_HASCREATED_FIRSTISSUE"] = "hasCreatedFirstIssue";
    ViewFieldKey["ORG_NATIVEAPP_OPENED"] = "nativeAppHasBeenOpened";
    ViewFieldKey["ORG_WEBAPP_ACCESSED"] = "webAppHasBeenAccessed";
    ViewFieldKey["ORG_ISSETUP"] = "isSetup";
    // ORG TEMPLATE,
    ViewFieldKey["ORGTEMPLATE_TITLE"] = "templateTitle";
    ViewFieldKey["ORGTEMPLATE_ENABLED"] = "orgtemplateEnabled";
    ViewFieldKey["ORGTEMPLATE_ROLLOUT"] = "orgtemplateRollout";
    // USER GENERIC
    ViewFieldKey["EMAIL"] = "email";
    ViewFieldKey["TEL"] = "tel";
    // PLACE
    ViewFieldKey["PLACE_TIMEZONE"] = "timezone";
    // TEAMBOARD
    ViewFieldKey["TEAMBOARD_CODE"] = "teamboardCode";
    // STAFF
    ViewFieldKey["STAFF_TYPE"] = "staffType";
    ViewFieldKey["STAFF_POSITIONTEAMS"] = "positionTeams";
    ViewFieldKey["STAFF_POSITIONS"] = "positions";
    ViewFieldKey["STAFF_INVITESTATUS"] = "inviteStatus";
    ViewFieldKey["STAFF_INVITETOAPPSTATUS"] = "inviteToAppStatus";
    ViewFieldKey["STAFF_LASTLOGGEDIN"] = "lastLoggedIn";
    ViewFieldKey["STAFF_ENABLED"] = "staffEnabled";
    // SUPERUSER
    ViewFieldKey["SUPERUSER_TYPE"] = "superUserType";
    ViewFieldKey["SUPERUSER_ORGS"] = "superUserOrgs";
    // TASK
    ViewFieldKey["TASK_STARTED"] = "startedDate";
    ViewFieldKey["TASK_COMPLETED"] = "completedDate";
    ViewFieldKey["TASK_TYPE"] = "taskType";
    ViewFieldKey["TASK_STATUS"] = "taskStatus";
    ViewFieldKey["TASK_DURATION"] = "taskDuration";
    // TEMPLATE DEFINITION
    ViewFieldKey["TEMPLATE_SOURCE"] = "source";
    ViewFieldKey["TEMPLATE_CATEGORIES"] = "category";
    ViewFieldKey["TEMPLATE_INDUSTRY"] = "industry";
    //WORKFLOW
    ViewFieldKey["WORKFLOW_ENABLED"] = "workflowEnabled";
    ViewFieldKey["WORKFLOW_EVENT"] = "event";
    ViewFieldKey["WORKFLOW_ACTIONS"] = "actions";
    ViewFieldKey["WORKFLOW_CONDITIONS"] = "conditions";
})(ViewFieldKey = exports.ViewFieldKey || (exports.ViewFieldKey = {}));
exports.default = ViewFieldKey;
